module.exports = __webpack_public_path__ + "img/redeem_form1_th.b3cf7ee0.jpg";